import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import MovementsChart from '../../../part/components/analysis/edit/chart';

class PartMovements extends Component {
  constructor(props) {
    super(props);
    this.handleActiveBarClick = this.handleActiveBarClick.bind(this);
  }

  componentDidMount() {
    const {partCode} = this.props;

    this.props.getPartWeeklyMoves(partCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partCode !== this.props.partCode) {
      this.props.getPartWeeklyMoves(this.props.partCode);
    }
  }

  handleActiveBarClick(type, week) {
    const {partCode} = this.props;

    this.props.fetchWeeklyAnalysis(partCode, type, week);
  }

  render() {
    const {loadingWeeklyAnalysis, weeklyAnalysis, weeklyMoves, loadingWeeklyMoves} = this.props;

    if (loadingWeeklyMoves) {
      return (
        <Loader active inline='centered'>
          Consultando los movimientos semanales del repuesto...
        </Loader>
      );
    }

    return (
      <MovementsChart showTotals sales lostSales
        data={weeklyMoves}
        loadingWeeklyAnalysis={loadingWeeklyAnalysis}
        weeklyAnalysis={weeklyAnalysis}
        activeBarClick={this.handleActiveBarClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingWeeklyMoves': state.form.part.loadingWeeklyMoves,
    'loadingWeeklyAnalysis': state.form.part.loadingWeeklyAnalysis,
    'weeklyAnalysis': state.form.part.weeklyAnalysis || [],
    'weeklyMoves': state.form.part.weeklyMoves || [],
  };
};

const {fetchWeeklyAnalysis, getPartWeeklyMoves} = Actions;

export default connect(mapStateToProps, {fetchWeeklyAnalysis, getPartWeeklyMoves})(PartMovements);
